import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import HighlightedText from "components/atoms/HighlightedText";
import Icon, {
  SIZES as ICON_SIZES,
  STYLE_TYPES as ICON_STYLE_TYPES,
} from "components/atoms/Icon";

const SuggestionItem = ({
  className,
  highlightedText,
  isHighlighted,
  onTermSearch,
  onTermSelect,
  term,
}) => {
  const componentBaseClass = "sal-suggestion-item";
  const componentClass = classnames(componentBaseClass, className);
  const handleTermSearch = (event) => {
    event.preventDefault();
    onTermSearch(term);
  };
  const handleTermSelect = (event) => {
    event.preventDefault();
    onTermSelect(term);
  };

  return (
    <span className={componentClass}>
      <button
        className={classnames(componentBaseClass + "__text", {
          [componentBaseClass + "__text--hover"]: isHighlighted,
        })}
        onClick={handleTermSearch}
      >
        <HighlightedText text={term} highlighted={highlightedText} />
      </button>
      <button
        className={componentBaseClass + "__select-button"}
        onClick={handleTermSelect}
      >
        <Icon
          className={componentBaseClass + "__select-button-icon"}
          type={ICON_STYLE_TYPES.PFEIL_NACH_LINKS}
          size={ICON_SIZES.S}
        />
      </button>
    </span>
  );
};

SuggestionItem.propTypes = {
  className: PropTypes.string,
  highlightedText: PropTypes.string,
  isHighlighted: PropTypes.bool,
  onTermSearch: PropTypes.func,
  onTermSelect: PropTypes.func,
  term: PropTypes.string,
};

export default SuggestionItem;
